/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps } from '@wordpress/block-editor';


import { Placeholder, PanelBody, TextControl } from '@wordpress/components';

import { InnerBlocks, InspectorControls } from '@wordpress/block-editor';
/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';

/**
 * Icons
 */
import icons from './icons.js';
/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {WPElement} Element to render.
 */
export default function Edit(props) {
/*     const blockProps = useBlockProps(); */
    const
        ALLOWED_BLOCKS = [
            'core/paragraph',
            'core/heading',
            'core/columns',
            'core/column',
            'core/image',
            'momo-acg-forms/momo-form-elements',
            'momo-acg-forms/momo-form-submit',
            'momo-acg-forms/momo-form-result'
        ];
    const { attributes, setAttributes, blockProps, clientId, className } = props;

    const { header, subHeader } = attributes;
    const handleHeaderChange = (newText) => {
        setAttributes({ header: newText });
    };
    const handleSubHeaderChange = (newText) => {
        setAttributes({ subHeader: newText });
    };
    const customClassName = 'momo-acg-form-container-editor';

    const combinedClassNames = '${className} ${customClassName}';

    return (
        <div { ...blockProps } className={combinedClassNames}>
            <InspectorControls>
                <PanelBody title="Block Settings" initialOpen={true}>
                    <TextControl
                        label="Header"
                        value={header}
                        onChange={handleHeaderChange}
                    />
                    <TextControl
                        label={__('Subheader', 'momoacg')}
                        value={subHeader}
                        onChange={handleSubHeaderChange}
                    />
                </PanelBody>
            </InspectorControls>

            <Placeholder
                icon={icons.content}
                label={ __('MoMo Form Container', 'momoacg') }
                instructions= { __('Please insert needed form element(s) along with result section.', 'momoacg') }
                isColumnLayout
                >
                    <div className="momo-acg-ai-form-container">
                        <h3>{header}</h3>
                        <h4>{subHeader}</h4>
                        <div>
                            <InnerBlocks
                                allowedBlocks={ ALLOWED_BLOCKS }
                                parentClientId = { clientId }
                            />
                        </div>
                    </div>
            </Placeholder>
        </div>
    );
}
